import { Module } from "wrapper6";
import Glide from '@glidejs/glide';
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class CourseImageSlider extends Module {

	ready(app) {
        
        const SLIDER_CONTAINERS = document.querySelectorAll('.mtt-course-room-info');

        if (SLIDER_CONTAINERS.length > 0) {

            for (let i = 0; i < SLIDER_CONTAINERS.length; i++) {

                const SLIDER_CONTAINER = SLIDER_CONTAINERS[i];
                const GLIDE = SLIDER_CONTAINER.querySelector('.glide');

                if (GLIDE) {
                    
                    // setup slider
                    const SLIDER = new Glide(GLIDE, {
                        type: 'slider',
                        startAt: 0,
                        perView: 1,
                        gap: 0,
                        animationDuration: 800
                    });
    
                    // Mount slider
                    SLIDER.mount();
                }
            }
        }
    }
}